import styled, {CSSProperties} from 'styled-components';
import {palette} from '@/styles/palette';
import {interceptProps} from './utils';

export const Section = styled('section').withConfig({
  shouldForwardProp: interceptProps(['spacing', 'unit']),
})<{
  spacing?: number;
  unit?: number;
}>`
  margin-top: ${({spacing = 6, unit = 4}) => unit * spacing}px;
`;

export const PaddingBox = styled('div').withConfig({
  shouldForwardProp: interceptProps([
    'spacing',
    'left',
    'right',
    'top',
    'bottom',
  ]),
})<{
  spacing?: number | string | Array<string | number>;
  left?: number;
  right?: number;
  top?: number;
  bottom?: number;
}>`
  ${({spacing}) => {
    if (!spacing) {
      return '';
    }
    const array = Array.isArray(spacing) ? spacing : [spacing];
    return `padding: ${array
      .map((i) => (typeof i === 'string' ? i : `${i}px`))
      .join(' ')};`;
  }}
  ${({left}) => !!left && `padding-left: ${left}px;`}
  ${({right}) => !!right && `padding-right: ${right}px;`}
  ${({top}) => !!top && `padding-top: ${top}px;`}
  ${({bottom}) => !!bottom && `padding-bottom: ${bottom}px;`}
`;

export const Flexbox = styled('div').withConfig({
  shouldForwardProp: interceptProps(['alignItems', 'justifyContent', 'gap']),
})<{
  alignItems?: CSSProperties['alignItems'];
  justifyContent?: CSSProperties['justifyContent'];
  gap?: CSSProperties['gap'];
}>`
  display: flex;
  align-items: ${({alignItems = 'center'}) => alignItems};
  ${({justifyContent}) =>
    justifyContent && `justify-content: ${justifyContent}`};
  ${({gap}) => gap && `gap: ${gap}`};
`;

export const ColumnFlexBox = styled('div').withConfig({
  shouldForwardProp: interceptProps(['gap']),
})<{
  gap?: number | string;
}>`
  display: flex;
  flex-direction: column;
  ${({gap}) => gap && `gap: ${typeof gap === 'number' ? `${gap}px` : gap};`}
`;

export const FlexCenter = styled(Flexbox)`
  justify-content: center;
`;

export const FlexFullGrow = styled.div`
  flex-grow: 1;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${palette.gray200};
`;

export const VerticalDivider = styled.div`
  width: 1px;
  height: 100%;
  background-color: ${palette.gray200};
`;

export const BackgroundImage = styled.div`
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

export const TransparentBackdrop = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const LinkText = styled.a`
  color: ${palette.blue400};
  font-weight: 700;
  text-decoration-line: underline;
  cursor: pointer;
`;

export const MultiLineEllipsis = styled('div').withConfig({
  shouldForwardProp: interceptProps(['lineClamp']),
})<{
  lineClamp: number;
}>`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${({lineClamp}) => lineClamp};
  -webkit-box-orient: vertical;
`;
